import { Row } from 'antd'
import Table from 'app/components/Core/PriceList/CategoryItem/Table'
import DeliveryItemTable from 'app/components/Core/PriceList/DeliveryItem/Table'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import { RecordType } from 'app/constants/GlobalTypes'
import useTranslation from 'app/lib/hooks/useTranslation'
import React from 'react'

type Props = {
  priceList: IPriceList
}

const PriceListTables: React.FC<Props> = ({ priceList }) => {
  const { tComponent } = useTranslation({
    recordType: RecordType.price_list,
    componentType: 'core',
    scope: 'table'
  })
  const showInsurance =
    !priceList?.referencePriceList && priceList?.insurancePolicy == 'fixed_price'

  return (
    <Row gutter={[12, 24]}>
      {priceList?.priceListItemsByCategories.map(({ category, priceListItems, ranges, id }) => (
        <KCol span={24} key={id} render={Boolean(priceListItems?.length)}>
          <Row>
            <KCol span={24}>
              <h5 className="mb-0">{category?.name}</h5>
            </KCol>
            <KCol span={24}>
              <Table
                dataSource={priceListItems}
                ranges={ranges}
                showSearch={false}
                showInsurance={showInsurance}
              />
            </KCol>
          </Row>
        </KCol>
      ))}
      <If condition={priceList.priceListDeliveryItems?.length}>
        <KCol span={24} key="delivery_price">
          <Row>
            <KCol span={24}>
              <h5 className="mb-0">{tComponent({ id: 'delivery_price' })}</h5>
            </KCol>
            <KCol span={24}>
              <DeliveryItemTable
                dataSource={priceList.priceListDeliveryItems}
                deliveryPriceRate={priceList.deliveryPriceRate}
                showSearch={false}
              />
            </KCol>
          </Row>
        </KCol>
      </If>
    </Row>
  )
}

export default PriceListTables
